import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import Modal from 'chameleon/ui-stack/ui/base/modal';

const InformationalModal = (props) => {
  const {
    children,
    title,
    dialogClassName,
    wrapperClassName,
    headingClassName,
    contentClassName,
    onClose,
    contentLabel,
    aria,
    size,
    isContainingBlock,
    isScrollableContent,
    hasTitleWithTooltip,
  } = props;

  return createPortal(
    <Modal
      size={size}
      title={title}
      dialogClassName={dialogClassName}
      wrapperClassName={wrapperClassName}
      headingClassName={headingClassName}
      contentClassName={contentClassName}
      contentLabel={contentLabel}
      aria={aria}
      onClose={onClose}
      isContainingBlock={isContainingBlock}
      isScrollableContent={isScrollableContent}
      hasTitleWithTooltip={hasTitleWithTooltip}
    >
      {children}
    </Modal>,
    document.querySelector('#modal'),
  );
};

InformationalModal.propTypes = {
  // The title of the modal
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // The class to style the dialog window.
  dialogClassName: PropTypes.string,
  // The class to style the modal content.
  contentClassName: PropTypes.string,
  // The class to style the modal wrapper.
  wrapperClassName: PropTypes.string,
  // The class to style the modal heading title.
  headingClassName: PropTypes.string,
  // Callback for closing the modal.
  onClose: PropTypes.func,
  // The accessibility content label
  contentLabel: PropTypes.func,
  // Object for setting accessibility aria options
  aria: PropTypes.object,
  // Sets the size of the modal
  size: PropTypes.string,
  // Transforms the wrapper container into a Containing Block
  isContainingBlock: PropTypes.bool,
  // If true it removes the scrolls from modal body
  isScrollableContent: PropTypes.bool,
  // If true the title tooltip algorithm is used to determine
  // if title needs tooltip
  hasTitleWithTooltip: PropTypes.bool,
};

InformationalModal.defaultProps = {
  title: <div />,
  dialogClassName: null,
  contentClassName: null,
  wrapperClassName: null,
  headingClassName: null,
  showCloseButton: true,
  onClose: () => {},
  contentLabel: '',
  aria: {},
  size: 'small',
  isContainingBlock: false,
  isScrollableContent: true,
  hasTitleWithTooltip: true,
};

export default InformationalModal;
